import request from '@/utils/request'

// 任务状态
export function getStatus(projectId) {
  return request({
    url: `task/allTask?project_id=${projectId}`,
    method: 'get'
  })
}

// 状态任务列表
export function getAllTask(projectId) {
  return request({
    url: `task/index/?all_task=1&project_id=${projectId}`,
    method: 'get'
  })
}

// 状态栏获取/待开发等
export function getAllStatus() {
  return request({
    url: `task/allTask`,
    method: 'get'
  })
}

// 状态查询按钮
export function taskStatus(reqParams) {
  return request({
    // url: `task/index?task_status=${taskStatus}&project_id=${projectId}`,
    url: `task/index`,
    method: 'post',
    data: reqParams
  })
}

// 表单查询按钮/任务列表
export function taskSelect(reqParams) {
  return request({
    url: 'task/select',
    method: 'post',
    data: reqParams
  })
}

// 记录工时/task/edit
export function recordHours(reqParams) {
  return request({
    url: 'task/edit',
    method: 'post',
    data: reqParams
  })
}

// 暂停
export function updateStatus(reqParams) {
  return request({
    url: `task/discard`,
    method: 'post',
    data: reqParams
  })
}

// 开始开发接口
export function listBtn(reqParams) {
  return request({
    url: `task/edit`,
    method: 'post',
    data: reqParams
  })
}

// 获取工时
// 工时列表/task/edit
export function hoursList(taskId, typeId) {
  return request({
    url: `task/edit?task_id=${taskId}&get_task_tims=1&tt_type=${typeId}`,
    method: 'get'
  })
}

// 工时列表/task/edit
export function editHoursList(reqParams) {
  return request({
    url: `task/edit`,
    method: 'post',
    data: reqParams
  })
}

// 任务导出
export function exportTaskStatistics(params) {
  return request({
    url: `statistics/exportTaskStatistics`,
    method: 'post',
    params: params
  })
}
